import { getHours, isWeekend } from "date-fns";

const TIMEZONE = "America/Phoenix";

export interface IntakeOfficeAvailabilityRange {
  close: number;
  open: number;
}

export interface IntakeOfficeAvailabilityConfig {
  days: "weekdays" | "all";
  ranges: IntakeOfficeAvailabilityRange[];
}

export interface IntakeOfficeAvailability {
  availabilityRange: IntakeOfficeAvailabilityRange | null;
  isAvailable: boolean;
}

export function getIntakeOfficeAvailability(
  config: IntakeOfficeAvailabilityConfig,
): IntakeOfficeAvailability {
  const now = new Date();
  const localeDateNowString = now.toLocaleString("en-US", {
    timeZone: TIMEZONE,
    hour12: false,
  });

  const localeDateNow = new Date(localeDateNowString);
  const localeHourNow = getHours(localeDateNow);

  let isValidDay = true;
  if (config.days === "weekdays") {
    isValidDay = !isWeekend(localeDateNow);
  }

  let range: IntakeOfficeAvailabilityRange | null = null;
  if (isValidDay) {
    range =
      config.ranges.find((range) => {
        return localeHourNow >= range.open && localeHourNow < range.close;
      }) ?? null;
  }

  return {
    isAvailable: isValidDay && range !== null,
    availabilityRange: range,
  };
}

export const immigrationConfig: IntakeOfficeAvailabilityConfig = {
  days: "weekdays",
  ranges: [
    {
      open: 7,
      close: 12,
    },
    {
      open: 13,
      close: 15,
    },
  ],
};

export const familyConfig: IntakeOfficeAvailabilityConfig = {
  days: "all",
  ranges: [
    {
      open: 6,
      close: 15,
    },
  ],
};
